import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

// Keeps secondary explanations out of the layout. Opens on hover and keyboard
// focus, and toggles on tap so touch users can read it too.
const InfoTip = ({ label, children, side = 'top', testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            onClick={() => setOpen((current) => !current)}
            className="qflow-info-tip"
            data-testid={testId}
          >
            <Info size={14} aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="qflow-tip-content">{children}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTip;
